import {
	DateTimePicker,
	DateTimePickerProps,
} from '@mui/x-date-pickers/DateTimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers';
import { useLocalizationContext } from '@mui/x-date-pickers/internals';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { DateTime } from 'luxon';
import { TextFieldProps } from '../text-field';

type DateTimePickerFieldProps = DateTimePickerProps &
	Omit<
		TextFieldProps,
		| 'value'
		| 'onChange'
		| 'multiline'
		| 'type'
		| 'rows'
		| 'maxRows'
		| 'minRows'
		| 'select'
		| 'SelectProps'
		| 'type'
		| 'defaultValue'
	> & {
		'data-test-id'?: string;
	};

function normalizePickerValue(value: unknown): DateTime | null {
	if (value == null) return null;
	if (DateTime.isDateTime(value)) return value;
	if (typeof value === 'string') {
		const parsed = DateTime.fromISO(value);
		return parsed.isValid ? parsed : null;
	}
	return null;
}

export const DateTimePickerField = (props: DateTimePickerFieldProps) => {
	const { helperText, error, onFocus, size, onBlur, value, ...rest } = props;
	const context = useLocalizationContext();

	// Don't render if localization context (adapter) is not available yet
	if (!context?.utils) {
		return null;
	}

	const pickerValue = normalizePickerValue(value);

	return (
		<DateTimePicker
			{...rest}
			value={pickerValue}
			slots={{
				openPickerIcon: EventNoteIcon,
			}}
			viewRenderers={{
				hours: renderTimeViewClock,
				minutes: renderTimeViewClock,
				seconds: renderTimeViewClock,
			}}
			format='M/d/yyyy   h:mm a'
			slotProps={{
				textField: {
					...(rest['data-test-id'] && {
						'data-test-id': rest['data-test-id'],
					}),
					error,
					helperText,
					onFocus,
					onBlur,
					size,
				},
			}}
			views={['month', 'day']}
		/>
	);
};
